import { configureStore } from "@reduxjs/toolkit";
import blogSlice from "../features/blog/blogSlice";
import blogsSlice from "../features/blogs/blogsSlice";
import filterSlice from "../features/filter/filterSlice";
import likeAndSavedSlice from "../features/likeAndSaved/likeAndSavedSlice";
import relatedBlogsSlice from "../features/relatedBlogs/relatedBlogsSlice";

export const store = configureStore({
  reducer: {
    blogs: blogsSlice,
    blog: blogSlice,
    relatedBlogs: relatedBlogsSlice,
    filters: filterSlice,
    likeAndSaved: likeAndSavedSlice,
  },
});
